import { create } from "zustand";
import { persist } from "zustand/middleware";
import {
  Language,
  SUPPORTED_APP_LANGUAGES,
  DEFAULT_APP_LANGUAGE,
  DEFAULT_VOICE_LANGUAGE,
  SUPPORTED_VOICE_LANGUAGES,
} from "../types/language";

interface LanguageState {
  appLanguage: string;
  voiceLanguage: string;
  voiceOn: boolean;
  voiceNames: Language[];
  selectedVoiceName: string;
  setAppLanguage: (language: string) => void;
  setVoiceLanguage: (language: string) => void;
  getAppLanguageName: (code: string) => string;
  getVoiceLanguageName: (code: string) => string;
  setVoiceOn: (voiceOn: boolean) => void;
  setVoiceNames: (voices: Language[]) => void;
  setSelectedVoiceName: (voice: string) => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      appLanguage: DEFAULT_APP_LANGUAGE,
      voiceLanguage: DEFAULT_VOICE_LANGUAGE,
      voiceOn: true,
      voiceNames: [],
      selectedVoiceName: "",
      setAppLanguage: (language: string) => set({ appLanguage: language }),

      setVoiceLanguage: (language: string) => set({ voiceLanguage: language }),

      getAppLanguageName: (code: string) => {
        const language = SUPPORTED_APP_LANGUAGES.find(
          (lang: Language) => lang.code === code
        );
        return language?.name || code.toUpperCase();
      },

      getVoiceLanguageName: (code: string) => {
        const language = SUPPORTED_VOICE_LANGUAGES.find(
          (lang: Language) => lang.code === code
        );
        return language?.name || code.toUpperCase();
      },

      setVoiceOn: (voiceOn: boolean) => set({ voiceOn: voiceOn }),

      setVoiceNames: (voices: Language[]) => {
        if (voices.length > 0) {
          set({ voiceNames: voices, selectedVoiceName: voices[0].name });
        }
      },
      setSelectedVoiceName: (voice: string) =>
        set({ selectedVoiceName: voice }),
    }),
    {
      name: "language-storage", // localStorage key
      partialize: (state) => ({
        appLanguage: state.appLanguage,
        voiceLanguage: state.voiceLanguage,
      }),
    }
  )
);
